import reprocessPncpIntegration from '@/resources/admin/pncp';

const actions = {
  async reprocessPncp(_context, payload) {
    const response = await reprocessPncpIntegration(payload);

    if (response.status < 200 || response.status >= 300) {
      return Promise.reject(response.data);
    }

    return Promise.resolve(response.data || null);
  },
};

export default {
  namespaced: true,
  actions,
};
